import { trackInteraction, trackVisible } from '../tracking'

interface EducationFormData {
  provider: 'google' | 'apple' | 'email'
  rejected: boolean
}

// tracking: registration.welcome.view
// The page shows the user's e-mail address, so element.text stays empty.
up.compiler('[data-onboarding-welcome]', (element: HTMLElement) =>
  trackVisible({ id: 'onboarding.welcome', text: '' })(element),
)

up.compiler(
  '[data-onboarding-education-form]',
  (form: HTMLFormElement, { provider, rejected }: EducationFormData) => {
    // The radio buttons come after simple_form's empty hidden field of the same name.
    const educationLevel = () =>
      new FormData(form).getAll('user[education_level]').filter(Boolean).pop() ?? null

    if (rejected) {
      // tracking: registration.education.error
      for (const field of invalidFieldNames(form)) {
        trackInteraction(
          'form.error',
          {
            id: 'onboarding.education_error',
            text: '',
            params: { form_error: field, education_level: educationLevel() },
          },
          form,
        )
      }
    } else {
      // tracking: registration.education.view
      // Re-rendering the form with errors is the same showing of the step.
      const stopTrackingVisible = trackVisible({
        id: 'onboarding.education_step',
        text: '',
        params: { provider },
      })(form)
      up.destructor(form, () => stopTrackingVisible?.())
    }

    // tracking: registration.education.submit
    form.addEventListener('submit', () => {
      trackInteraction(
        'submit.form',
        {
          id: 'onboarding.education_submit',
          params: { provider, education_level: educationLevel() },
        },
        form.querySelector<HTMLElement>('[type=submit]') ?? form,
      )
    })
  },
)

// The innermost segment of each invalid field's name, once per field (radio buttons share one).
function invalidFieldNames(form: HTMLFormElement): Set<string> {
  const names = new Set<string>()
  for (const input of form.querySelectorAll<HTMLInputElement>('.is-invalid[name]')) {
    const name = input.name.match(/\[([^\]]+)\]$/)?.[1] ?? input.name
    names.add(name)
  }
  return names
}
